import { render, staticRenderFns } from "./TypeOfExistingRadiatorFormPart.vue?vue&type=template&id=0bff4ed1"
import script from "./TypeOfExistingRadiatorFormPart.vue?vue&type=script&lang=js"
export * from "./TypeOfExistingRadiatorFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports